import Vue from 'vue';
import Vuex from 'vuex';
import { LocalStoragePlugin, AbilityPlugin } from '@switchsystems/coactive-vue-lib';
import DataDogPlugin from './lib/datadog';
import jobapplications from './modules/jobapplications';
import jobopportunities from './modules/jobopportunities';
import userstate from './modules/userstate';
import register from './modules/register';
import auth from './modules/auth';
import settings from './modules/settings';
import user from './modules/user';

Vue.use(Vuex);

const store = {
  plugins: [
    LocalStoragePlugin({
      storedKeys: ['auth', 'userstate', 'register', 'settings'],
      destroyOn: ['auth/logoutUser'],
    }),
    // AbilityPlugin must directly follow LocalStoragePlugin
    AbilityPlugin,
    DataDogPlugin(),
  ],
  modules: {
    auth,
    jobapplications,
    jobopportunities,
    userstate,
    register,
    settings,
    user,
  },
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
};

export default new Vuex.Store(store);
